import React from 'react';
import { ShieldCheck, Tags, PackageSearch, Truck } from 'lucide-react';
const values = [{
  icon: ShieldCheck,
  title: 'Qualité Garantie',
  description: 'Des produits rigoureusement sélectionnés pour vous.'
}, {
  icon: Tags,
  title: 'Meilleurs Prix',
  description: "Des tarifs dégressifs et compétitifs toute l'année."
}, {
  icon: PackageSearch,
  title: 'Large Choix',
  description: 'Des milliers de références dans toutes les catégories.'
}, {
  icon: Truck,
  title: 'Livraison Rapide',
  description: 'Un réseau logistique performant et fiable.'
}];
export function ValueProps() {
  return <section className="py-16 bg-brand-navy text-white" data-id="element-136">
      <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-137">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12" data-id="element-138">
          {values.map((value, index) => {
          const Icon = value.icon;
          return <div key={index} className="flex flex-col items-center text-center group" data-id="element-139">
                <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-gold group-hover:text-brand-navy transition-colors duration-300" data-id="element-140">
                  <Icon className="w-8 h-8" data-id="element-141" />
                </div>
                <h3 className="text-xl font-heading font-bold mb-3" data-id="element-142">
                  {value.title}
                </h3>
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-143">
                  {value.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}